import Vue from 'vue'
import { ajax } from '@/plugins/ajax'

export default {
  namespaced: true,
  state: {
    details: [],
    loading: false,
    model: {
      orderId: '',
      storeId: '',
      shelveId:'',
      shelveName: '',
      returnOrderItemsCommand: [
        {
          productId: 0,
          count: 0,
          serials:null
        }
      ]
    },
    selectedTransactionIndex: null,

  },
  getters: {
    model: (state) => state.model,

    details: (state) => state.details,
    loading: (state) => state.loading
  },
  actions: {
    create({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax.post('Sales/api/ReturnOrders', model).then(r => {
          resolve(r.data);
        }).catch(e => {
          reject(e.response.data)
        });
      })
    },
    fetchSingle({ commit }, id) {
      commit('setLoading', true);
      return new Promise((resolve, reject) => {
        ajax.get('Sales/api/ReturnOrdersQuery/' + id).then(r => {
          commit('setDetails', r.data);
          commit('setLoading', false);
          resolve(r.data)
        }).catch(e => reject(e))
      })
    },
    addSerialToSelectedTransaction({ commit }, name) {
      commit('addSerialToSelectedTransaction', name);
    },
    setSelectedTransactionIndex({ commit }, index) {
      commit('setSelectedTransactionIndex', index);
    },
  },
  mutations: {
    setDetails(state, data) {
      state.details = data;
    },
    setLoading(state, value) {
      state.loading = value;
    },
    addSerialToSelectedTransaction(state, name) {
      var returnOrderItemsCommand = state.model.returnOrderItemsCommand[state.selectedTransactionIndex];
      if (!returnOrderItemsCommand.serials) returnOrderItemsCommand.serials = [];
      returnOrderItemsCommand.serials.push(name);
      Vue.set(state.model.returnOrderItemsCommand, state.selectedTransactionIndex, returnOrderItemsCommand)
    },
    setSelectedTransactionIndex(state, index) {
      state.selectedTransactionIndex = index;
    }
  }

}
